<template>
  <div
    class="change-system-content"
    :class="{'border-top':borderTop}"
  >
    <div class="change-system-content_title">
      <div class="change-system-content_title-icon">
        <i
          v-if="icon"
          class="conent-icon"
          :class="icon"
        />
        <img
          v-if="iconImage"
          :src="iconImage"
          alt=""
          class="content-icon-img"
        >
      </div>
      <p class="content-title">
        {{ title }}
      </p>
    </div>
    <div class="change-system-content_content-wrap">
      <LlState
        required
        type="member"
        rules="required"
        :placeholder="$t('請選擇評估人員')"
        :title="$t('指定評估人員')"
        leading-icon="icon-outline-perm-identity"
        :value="taker"
        @input="selectSytemtTaker($event)"
      />
      <div
        v-if="changeList.length > 0"
        class="content-card-list-wrap"
      >
        <p class="content-card-list_title">
          {{ $t('ESGoal建議應檢視項目') }}
        </p>
        <div class="content-card-list">
          <ChangeContentCard
            v-for="(change,changeIndex) in changeList"
            :key="changeIndex"
            :title="change.title"
            :attaches="change.attaches"
            :description="change.description"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ChangeSystemContent",
  props: {
    icon: {
      type: String,
      default: "icon-water",
    },
    iconImage: {
      type: String,
      default: "",
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    taker: {
      type: Number,
      default: 0,
    },
    changeList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    selectSytemtTaker($event) {
      this.$emit("taker-select", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/change-system-content";
</style>